const convertArrayToObject = (array, key) => {
  const initialValue = {};

  return array.reduce((obj, item) => {
    return {
      ...obj,
      [item[key]]: item,
    };
  }, initialValue);
};

const extractFormKeysFromObject = (form, mainObject) => {
  mainObject = mainObject || {};
  
  var keysNeeded = [];

  form.forEach((row) => {
    row.forEach((column) => {
      if (column.key) {
        keysNeeded.push(column.key);
      }
    });
  });

  return Object.keys(mainObject)
    .filter((key) => keysNeeded.includes(key))
    .reduce((res, key) => ((res[key] = mainObject[key]), res), {});
}

export {
  convertArrayToObject,
  extractFormKeysFromObject
}